import type { RootState } from '../../../store'

export const selectCurrentVehicle = (state: RootState) => state.vehicle.current
